import { matchPath, useLocation } from 'react-router-dom';
import PATHS from '../../../routes/routes.const';
import { useAppEnvironmentStore } from '../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInStoreEnvironment } from '../../../stores/AppEnvironment/appEnvironment.store.selectors';
import { useRachelStore } from '../store/rachel.store';
import { selectIsRachelOpen } from '../store/rachel.store.selectors';

export const useIsRachelFooterInputVisible = () => {
  const { pathname } = useLocation();
  const isOpen = useRachelStore(selectIsRachelOpen);
  const isInStoreEnvironment = useAppEnvironmentStore(selectIsInStoreEnvironment);
  const isOnHome = !!matchPath(pathname, { path: PATHS.main.home.path, exact: true });
  const isOnBrandHome = isOnHome && !isInStoreEnvironment;

  return !isOnBrandHome || isOpen;
};
